import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Sizes from 'UI/sizes';
import Button from '../Button';

export default class IconButton extends React.Component
{
    render()
    {
        const classes = classNames(
            'border-none shadow-none p-1',
            this.props.className,
        );

        return <Button size={Sizes.NONE} className={classes} {...this.props}>
            { this.props.children }
        </Button>;
    }
}
